
export default class QuickQuoteFlow {
    constructor(vm) {
        this.vm = vm;
    }

    get(event) {
        let trackingObject = null;

        switch (event) {
            case 'quick-quote-error-modal-show':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'valideringsfejl',
                    'eventAction': 'impression',
                    'eventLabel': this.vm.url,
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;
            
            case 'quick-quote-error-modal-button-click':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'valideringsfejl',
                    'eventAction': 'CTA klik',
                    'eventLabel': this.vm,
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;
            
            case 'quick-quote-error-modal-error-message':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'valideringsfejl',
                    'eventAction': 'error message',
                    'eventLabel': this.vm,
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;
        }
        
        return trackingObject;
    }
}
